/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Intervals_No_Activities_DescInputs */

const en_toast_intervals_no_activities_desc = /** @type {(inputs: Toast_Intervals_No_Activities_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We found no rides or runs to import. Activities that reach intervals.icu through Strava can't be shared with other apps — connect your device to intervals.icu directly or upload FIT files.`)
};

const de_toast_intervals_no_activities_desc = /** @type {(inputs: Toast_Intervals_No_Activities_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir haben keine Läufe oder Radfahrten zum Importieren gefunden. Aktivitäten, die über Strava zu intervals.icu kommen, dürfen nicht an andere Apps weitergegeben werden – verbinde dein Gerät direkt mit intervals.icu oder lade FIT-Dateien hoch.`)
};

/**
* | output |
* | --- |
* | "We found no rides or runs to import. Activities that reach intervals.icu through Strava can't be shared with other apps — connect your device to intervals.ic..." |
*
* @param {Toast_Intervals_No_Activities_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_intervals_no_activities_desc = /** @type {((inputs?: Toast_Intervals_No_Activities_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Intervals_No_Activities_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_intervals_no_activities_desc(inputs)
	return de_toast_intervals_no_activities_desc(inputs)
});